import { render, staticRenderFns } from "./SetPicker.vue?vue&type=template&id=20f87638&"
import script from "./SetPicker.vue?vue&type=script&lang=js&"
export * from "./SetPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports